import angular from 'angular';

const kformMaxDirective = /* @ngInject */ () => ({
	restrict: 'A',
	require:  'ngModel',
	link:     (
		/** @type {any} */ scope,
		/** @type {any} */ element,
		/** @type {any} */ attributes,
		/** @type {any} */ ctrl,
	) => {
		/** @type {number | undefined} */
		let maxValue;
		ctrl.$validators.max = (/** @type {string} */ value) => {
			if (ctrl.$isEmpty(value) || angular.isUndefined(maxValue)) {
				return true;
			}

			const valueAsNumber = angular.isNumber(value) ? value : Number.parseFloat(value);
			return maxValue === undefined ? true : (valueAsNumber <= maxValue);
		};

		scope.$watch(attributes.kformMax, (/** @type {any} */ value) => {
			if (angular.isDefined(value) && !angular.isNumber(value)) {
				// eslint-disable-next-line no-param-reassign
				value = Number.parseFloat(value);
			}
			maxValue = angular.isNumber(value) && !Number.isNaN(value) ? value : undefined;
			ctrl.$validate();
		});
	},
});

export default kformMaxDirective;
